import styled, { css } from 'styled-components';
import { widgetNavIsHidden } from '../../../helpers/widget';
import { SIDE_BAR_POSITION } from '../../../types/sideBar';

interface ContainerProps {
  offset: number;
  sideBarPosition: string;
}

interface FullscreenProps {
  offset: number;
}

export default {
  Container: styled.div<ContainerProps>`
    position: absolute;
    left: 24px;
    top: 50%;
    margin-top: ${(props) => (widgetNavIsHidden(props) ? 0 : 60)}px;
    transform: translateY(-50%);
    transition: 0.2s ease-out;
    z-index: 3;

    ${({ sideBarPosition }) => {
      if (
        sideBarPosition &&
        sideBarPosition === SIDE_BAR_POSITION.MIDDLE &&
        window.Widget.announcementsController.count !== 0
      ) {
        return css`
          top: calc(50% - 100px);
        `;
      }
    }}

    @media screen and (max-width: 700px) {
      transform: none;
    }

    @media (max-width: 1024px) {
      left: 8px;
    }

    @media screen and (min-width: 768px) {
      top: 50%;
      transform: translateY(-50%);
    }

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: 24px;
        left: unset;

        @media (max-width: 1024px) {
          right: 8px;
          left: unset;
        }
      `}
  `,

  Sign: styled.div`
    height: 17px;
    width: 17px;
    line-height: 11px;
  `,

  Fullscreen: styled.div<FullscreenProps>`
    position: absolute;
    bottom: ${(props) => props.offset + 24}px;
    left: 24px;
    z-index: 3;

    @media (max-width: 1024px) {
      left: 8px;
      bottom: ${(props) => props.offset + 8}px;
    }

    ${(props) =>
      props.theme.isRtl &&
      css`
        right: 24px;
        left: unset;

        @media (max-width: 1024px) {
          right: 8px;
          left: unset;
        }
      `}
  `,
};
